import React, { Component } from "react";
import { Link } from "react-router-dom";
import SLUGS from '../../resources/slugs';
class SuccessStoriesButton extends Component{
  

		render(){
			return(
				<Link to={SLUGS.successStories} title="view success story">view success story</Link>
			)
		}
}

export default SuccessStoriesButton;